module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAQBJREFUKBVjDA1tYPsrJmHx+zfjmc2z0r8xEAF802ZysbL+N2F+9eIEE4O4ZC8zI9NBdlbGZaFZU3kI6Qep4WBlWA7SwyAq0cXE8JdhBwPD/0+MjAz+DIwsS/EZApYDqmFgZPQD6fnHyLCLEWRjcPYMLyZGxuUMDIx8DP//b2L4/yd69bTsL8iuwdD8/3/k2qkZ28AGgBSGZM7yZGT+vwKbIeia//9ljFgzPW07SB/cABAHwyWvvkb8EORmBPkZ5mxkzRgGgARQXMLwf8P//4xAAAwfoJ/RNWM1ANMQkAh2zTgNgBvC9B8YsEDt/xgjYX4G8YkGgRnTdYKzp2jj0wAAaKR7Y1eu/30AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/assets/img/arrow.png
// module id = ../../../../../src/assets/img/arrow.png
// module chunks = main